export enum PhotoReportTagPositionType {
  DontPrint = 0,
  PrintAbovePictures = 1,
  PrintBelowPictures = 2,
}

